module.exports = __webpack_public_path__ + "assets/img/flow03.78778e1e.png";